module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_9016.6fc8d3f9.png";